import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    userCard: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: "center",
        paddingLeft: 15,
        borderStyle: "solid",
        borderWidth: (props) => props.mdComplete ? 1 : 2,
        borderColor: (props) => props.mdComplete ? theme.palette.secondary.main : theme.palette.error.main,
        backgroundColor: theme.palette.background.paper
    },
    userCardContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: "start",
        width: "100%",
        padding: 0,
        paddingLeft: 15
    },
    userHeader: {
        color: theme.palette.text.primary,
        textAlign: "left",
        fontWeight: "bolder",
        fontSize: (props) => props.headerSize ? props.headerSize : 16
    },
    userContent: {
        color: theme.palette.text.secondary,
        textAlign: "left",
        paddingTop: 2,
        fontSize: (props) => props.textSize ? props.textSize : 12
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: "center",
        paddingRight: 5,
        color: theme.palette.text.secondary
    },
    tightRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: "center"
    }
}));

export {useStyles};
